var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipEngage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "48px",
    viewBox: "0 -960 960 960",
    width: "48px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M220-80q-24 0-42-18t-18-42v-680q0-24 18-42t42-18h361l219 219v521q0 24-18 42t-42 18H220Zm0-60h520v-494H554v-186H220v680Zm260.26-80q58.74 0 99.24-41.13Q620-302.25 620-360v-140h-40v140q0 42-28.75 71T480-260q-42 0-71-29t-29-71v-220q0-18 11.5-29t28.5-11q18 0 29 11t11 29v200h40v-200q0-33.6-23.08-56.8-23.07-23.2-56.5-23.2-33.42 0-56.92 23.2T340-580v220q0 57.75 41.2 98.87Q422.41-220 480.26-220ZM220-820v186-186 680-680Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipEngage);
export default __webpack_public_path__ + "static/media/clip_engage.bbeb5de64cecd4eb3dc0907a18beaa1a.svg";
export { ForwardRef as ReactComponent };